module.exports = __webpack_public_path__ + "img/block3.eee695d3.svg";